import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class RbacService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get all available project roles
     * Get all available project roles based on organization plan.
     * @returns ProjectRoleDetails OK.
     * @throws ApiError
     */
    getOrganizationProjectRoles({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/project-roles', path: {
                'orgId': orgId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get permissions for a project role
     * Get permissions for a project role.
     * @returns string OK.
     * @throws ApiError
     */
    getProjectRolePermissions({ orgId, roleName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/project-roles/{roleName}/permissions', path: {
                'orgId': orgId,
                'roleName': roleName,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get permissions for an organization role
     * Get permissions for an organization role.
     * @returns string OK.
     * @throws ApiError
     */
    getOrganizationRolePermissions({ orgId, roleName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/roles/{roleName}/permissions', path: {
                'orgId': orgId,
                'roleName': roleName,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get project RBAC config
     * @returns ProjectRbac OK.
     * @throws ApiError
     */
    getProjectBranchRbacConfig({ orgId, projectId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/rbac', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update project RBAC config
     * @returns UpdateProjectRbac OK.
     * @throws ApiError
     */
    updateProjectRbacConfig({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/rbac', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=RbacService.js.map